import { ref, watch } from 'vue'
import { safeLocalStorage, isClient } from '@/composables/useSSR'

const STORAGE_KEY = 'adminViewMode'

// Shared reactive state - default to true, load from storage on client
const adminViewMode = ref(true)

if (isClient) {
  const storage = safeLocalStorage()
  if (storage) {
    adminViewMode.value = storage.getItem(STORAGE_KEY) !== 'false'

    // Sync to localStorage
    watch(adminViewMode, (newValue) => {
      storage.setItem(STORAGE_KEY, String(newValue))
    })
  }
}

// Listen for storage changes from other tabs/components
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) {
      adminViewMode.value = e.newValue !== 'false'
    }
  })
}

export function useAdminViewMode() {
  const toggle = () => {
    adminViewMode.value = !adminViewMode.value
  }

  return {
    adminViewMode,
    toggle
  }
}
